import React, { forwardRef, useState } from 'react';
import classes from './DetalleEncuesta.css';
import {formatFechaDD_MM_YYYY} from '../../../shared/fechas';

// Material UI
import IconButton from '@material-ui/core/IconButton';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Collapse from '@material-ui/core/Collapse';

const DetalleEncuesta = forwardRef(function DetalleEncuesta({
  fechaSolicitud,
  fechaCierre,
  cliente,
  SolicitadaPor,
  RealizadaPor,
  Tema,
  Detalle,
  numeroEncuesta,
  mensajeBienvenida
}) {
  const [plegado, setPlegado] = useState(true);

  const allPropsEmpty =
    !fechaSolicitud &&
    !fechaCierre &&
    !cliente &&
    !SolicitadaPor &&
    !RealizadaPor &&
    !Tema &&
    !Detalle &&
    !numeroEncuesta &&
    !mensajeBienvenida;

  const togglePlegado = () => setPlegado((prev) => !prev);

  return (
    <div>
      {allPropsEmpty ? (
        <div className={classes.error}>
          <h2>Falta información</h2>
          <p>
            <b>Si estás viendo este mensaje es porque faltan detalles de la encuesta.</b>
          </p>
          <p>
            <b>Por favor, reportá esto al soporte técnico.</b>
          </p>
        </div>
      ) : (
        <div className={classes.infocard}>
          <div
            onClick={togglePlegado}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              cursor: 'pointer',
              userSelect: 'none',
              width: 'fit-content'
            }}
          >
            <IconButton disableRipple disableFocusRipple sx={{ padding: '4px', color: '#f1a208' }}>
              {plegado ? <ChevronRightIcon /> : <ExpandMoreIcon />}
            </IconButton>
            <h2 style={{ margin: 0 }}>Información de la encuesta</h2>
          </div>

          <Collapse in={!plegado} timeout="auto" unmountOnExit>
            {mensajeBienvenida && (
              <p>
                {mensajeBienvenida}
                <br />
              </p>
            )}
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div>
                <p>
                  <b>Cliente: </b>
                  {cliente}
                  <br />
                </p>
                <p>
                  <b>Tarea: </b>
                  {Tema}
                  <br />
                </p>
                <p>
                  <b>Solicitada por: </b>
                  {SolicitadaPor}
                  <br />
                </p>
              </div>
              <div>
                <p>
                  <b>Realizada por: </b>
                  {RealizadaPor}
                  <br />
                </p>
                <p>
                  <b>Fecha de solicitud: </b>
                  {formatFechaDD_MM_YYYY(fechaSolicitud)}
                  <br />
                </p>
                <p>
                  <b>Fecha de cierre: </b>
                  {formatFechaDD_MM_YYYY(fechaCierre)}
                  <br />
                </p>
              </div>
            </div>
          </Collapse>
        </div>
      )}
    </div>
  );
});

export default DetalleEncuesta;
